import { FaTimesCircle, FaCheckCircle } from "react-icons/fa";
import ModalWrapper from "../UI/ModalWrapper"
import { useState } from "react";
import CircularProgressCard from "../CircularProgressCard"
import useDelete from "../../Hooks/useDelete";
import ClipLoader from "react-spinners/ClipLoader";
import API_ENDPOINTS from "../../Config/api";
import ConfirmDelete from "../Modal/ConfirmDelete";
import { Icon } from "../UI/Icon";
import { useNavigate } from "react-router-dom";
import usePost from "../../Hooks/usePost";


export default function FornitoriAttiviTable({

  data = [],
  refreshData,
  searchTerm = "",

}) {

  const filtered = (data ?? []).filter((it) =>
    (it.ragione_sociale ?? "").toLowerCase().includes((searchTerm ?? "").toLowerCase())
  );


  return (
    <div className="flex flex-col h-96 ">
      <div className="flex-1 min-h-0 overflow-y-auto [scrollbar-gutter:stable] border-[#D1D5DB] border rounded">
        <table className="w-full table-auto text-sm text-slate-200 border-collapse">
          <colgroup>
            <col className="w-[30%]" />
            <col className="w-[10%]" />
            <col className="w-[10%]" />
            <col className="w-[10%]" />
            <col className="w-[10%]" />
            <col className="w-[10%]" />
            <col className="w-[10%]" />
            <col className="w-[10%]" />
          </colgroup>

          <thead className=" text-black text-sm sticky top-0 z-10 bg-[#F3F4F7]">
            <tr>
              <th className="px-3 py-5 text-left font-medium whitespace-nowrap">Ragione sociale</th>
              <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Partita iva</th>
              <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Consenso</th>
              <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Cyber Risk</th>
              <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Nis2 Risk</th>
              <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Rischio aggregato</th>
              <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Dettagli</th>
              <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Monitoraggio</th>
            </tr>
          </thead>

          <tbody>
            {filtered.length > 0 ? (
              filtered.map((item, i) => {
                // if (i === 0)
                return (
                  <Row key={i} item={item} refreshData={refreshData} />
                )
              }
              )
            ) : (
              <tr>
                <td colSpan={7} className="text-center py-6 text-slate-400">
                  Nessun fornitore trovato
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}



function Row({

  item,
  refreshData

}) {

  const { deleteData, loading: deleteDataLoading } = useDelete();
  const [showModal, setShowModal] = useState(false)

  const { postData, loading } = usePost();

  async function handleRevoke() {
    try {
      await deleteData(API_ENDPOINTS.revocaMonitoraggio(item.id));
      refreshData();
      setShowModal(false)
    } catch (err) {
      console.error(err);
      alert(`Errore revoca: ${err.message}`);
    }
  }


    const handleSsoLogin = async (row) => {

      try {
        const res = await postData(API_ENDPOINTS.tokenSso, {
          target_azienda_id: row.azienda_uuid,
        });
        if (res?.redirect_url) {
  
          let redurectUrl = res?.redirect_url
          // redurectUrl = res.redirect_url.replace('http://192.168.1.146:3000', 'http://localhost:3000');
  
          window.open(redurectUrl, '_blank');
        } else {
          alert('Nessun URL ricevuto');
        }
      } catch (err) {
        console.error('Errore SSO:', err);
        alert('Errore durante il login SSO');
      }
    };


  return (
    <>
      <tr className=" text-black border-white border-b-4 bg-[#E3E3E3]">

        {/* Ragione sociale */}
        <td className="px-3 py-3">
          <p className="font-semibold leading-tight">
            {item.ragione_sociale ?? "--"}
          </p>
        </td>

        {/* Valori */}
        <td className="px-3 py-3 text-center tabular-nums">
          {item.partita_iva ?? "--"}
        </td>
        <td className="px-3 py-3 text-center tabular-nums">
          <div className="flex justify-center">
            {
              item.consenso_condivisione ? (
                <FaCheckCircle className="text-green-600 w-5 h-5" />
              ) : (
                <FaTimesCircle className="text-red-600 w-5 h-5" />
              )
            }
          </div>
        </td>
        <td className="px-3 py-3 text-center tabular-nums">
          {item.cyber_risk_percent + "%" ?? "--"}
        </td>
        <td className="px-3 py-3 text-center tabular-nums">
          {item.nis2_noncompliance_risk_percent + "%" ?? "--"}
        </td>
        <td className="px-3 py-3 text-center tabular-nums">
          {item.overall_risk_percent + "%" ?? "--"}
        </td>

        <td className="px-3 py-3 flex justify-center tabular-nums ">
          <button
            onClick={() => handleSsoLogin(item)}
            className="p-2 rounded border hover:bg-gray-300 transition" aria-label="Revoca monitoraggio"
            title="Revoca monitoraggio"
          >
            <Icon name={'eye'} />
          </button>
        </td>
        <td className="px-3 py-3 text-center tabular-nums ">
          <button
            onClick={() => setShowModal(true)}
            disabled={deleteDataLoading}
            className={`w-full p-2 rounded-md border bg-red-500 hover:bg-red-600 text-white font-medium flex items-center justify-center gap-2 transition-colors duration-200hover:bg-red-600 hover:border-red-600disabled:opacity-50 disabled:cursor-not-allowed`}
            aria-label="Revoca monitoraggio"
            title="Revoca monitoraggio"
          >
            {deleteDataLoading ? <ClipLoader size={18} color="#fff" /> : "Revoca"}
          </button>
        </td>




        {/* <td className="px-3 py-3 text-center tabular-nums">
          {
            <button
              className="p-2 rounded border hover:bg-gray-300 transition"
              onClick={() => setShowModal(true)}
            >
              <FiEye className="text-gray-700 w-4 h-4" />
            </button>
            ?? "--"
          }
        </td> */}

      </tr>


      <ModalWrapper
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      >
        <ConfirmDelete
          message={`Vuoi revocare il monitoraggio di "${item.ragione_sociale}"?`}
          elementNameToDelete={"Revoca monitoraggio"}
          onConfirm={handleRevoke}
          onCancel={() => setShowModal(false)}
          confirmLabel="Revoca"
        />
      </ModalWrapper>
    </>
  );
}